import { SelectInput } from "./SelectInput";
import { PAYOR_PATH_OPTIONS } from "../../PayorPaths";
import React from "react";

export const PayorPathSelector = React.forwardRef((props, ref) => {
  return <SelectInput options={PAYOR_PATH_OPTIONS} ref={ref} {...props} />;
});
